import React, { useMemo } from 'react';
import { Line } from 'react-chartjs-2';

const PALETTE = ['#6366f1', '#10b981', '#f59e0b', '#38bdf8', '#f43f5e'];

const SystemMonitorChart = ({ title, history = [], series = [] }) => {
  const data = useMemo(() => ({
    labels: history.map((item) => new Date(item.ts).toLocaleTimeString('ru-RU', {
      hour: '2-digit',
      minute: '2-digit',
      second: history.length < 120 ? '2-digit' : undefined,
    })),
    datasets: series.map((item, index) => ({
      label: item.label,
      data: history.map((row) => {
        const value = Number(row?.[item.key]);
        return Number.isFinite(value) ? value : null;
      }),
      borderColor: PALETTE[index % PALETTE.length],
      backgroundColor: PALETTE[index % PALETTE.length],
      borderWidth: 2,
      pointRadius: 0,
      pointHoverRadius: 3,
      fill: false,
      lineTension: 0.18,
    })),
  }), [history, series]);

  const options = useMemo(() => ({
    animation: { duration: 0 },
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: true,
      labels: {
        fontColor: '#94a3b8',
        boxWidth: 10,
        usePointStyle: true,
      },
    },
    tooltips: {
      mode: 'index',
      intersect: false,
    },
    scales: {
      xAxes: [{
        gridLines: { display: false },
        ticks: {
          fontColor: '#94a3b8',
          maxTicksLimit: 7,
        },
      }],
      yAxes: [{
        gridLines: { color: 'rgba(148, 163, 184, .14)' },
        ticks: {
          beginAtZero: true,
          fontColor: '#94a3b8',
        },
      }],
    },
  }), []);

  return (
    <section className="systemMonitor__chartCard">
      <div className="systemMonitor__sectionTitle">{title}</div>
      <div className="systemMonitor__chartCanvas">
        <Line data={data} options={options} />
      </div>
    </section>
  );
};

export default SystemMonitorChart;
